import { Component, input, OnInit, inject, output } from '@angular/core';

import { CountrySelectorService } from './country-selector.service';
import { CountrySelectOption } from './model';

@Component({
    selector: 'vision2-country-selector',
    templateUrl: './country-selector.component.html',
    styleUrls: ['./country-selector.component.scss'],
    standalone: false,
})
export class CountrySelectorComponent implements OnInit {
    selectedCountryChange = output<CountrySelectOption>();

    name = input.required<string>();
    customError = input<string>('');
    label = input<string>('');
    errorIconImageUrl = input<string>('');

    options: any;

    private countryService = inject(CountrySelectorService);

    ngOnInit(): void {
        this.options = this.countryService.getCountries();
    }

    onCountryChange($event: CountrySelectOption) {
        this.selectedCountryChange.emit($event);
    }
}
